<template>
    <div class="flexFlags">
        <img 
            class="flagIcon"
            @click="switchLocale('et')"
            :src="require('@/assets/flags/et.svg')" 
            alt=""
        >
        <img 
            class="flagIcon"
            @click="switchLocale('en')"
            :src="require('@/assets/flags/en.svg')" 
            alt=""
        >
    </div>
</template>

<script>
import { useRouter } from 'vue-router';

export default {
    setup() {
        const router = useRouter();

        function switchLocale(locale) {
            const currentRoute = router.currentRoute.value;

            router.push({
                name: currentRoute.name,
                params: { ...currentRoute.params, locale },
                query: currentRoute.query,
            }).then(() => {
                window.location.reload(); // Full page reload
            });
        }

        return { switchLocale };
    }
};
</script>
<style scoped>
.flagIcon {
    width: 30px;
    cursor: pointer;
}
.flexFlags {
    display: flex;
    column-gap: 10px;
}
</style>
